import { useEffect, useRef, useState } from 'react';

/**
 * Detects scroll direction and whether the user is at the top of the page.
 * Used by the Nav to hide on scroll-down and show on scroll-up.
 */
export function useSmartScroll({ threshold = 8, downOffset = 80 } = {}) {
  const lastY = useRef(0);
  const [hidden, setHidden] = useState(false);
  const [atTop, setAtTop] = useState(true);

  useEffect(() => {
    let ticking = false;

    const onScroll = () => {
      const y = window.scrollY || 0;
      if (ticking) return;
      ticking = true;

      window.requestAnimationFrame(() => {
        const delta = y - lastY.current;
        setAtTop(y < threshold);

        if (Math.abs(delta) > 4) {
          const scrollingDown = delta > 0;
          setHidden(scrollingDown && y > downOffset);
          lastY.current = y;
        }
        ticking = false;
      });
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, [threshold, downOffset]);

  return { hidden, atTop };
}
